export const APPLY_COUPON = "APPLY_COUPON";
export const COUPON_ERROR = "COUPON_ERROR";
export const REMOVE_ONE_COUPON = "REMOVE_ONE_COUPON";
export const CLEAR_PENDING_APPLIED_COUPON = "CLEAR_PENDING_APPLIED_COUPON";
